export default "__VITE_ASSET__3Dr1BAeK__"